module.exports = __webpack_public_path__ + "img/jiantou.183c9c39.png";